module.exports = __webpack_public_path__ + "media/images/covid/icons/sheet-4f078955f557a4760e1f4154cc78dcf2.png";